export const PRICING_DEFAULTS = {
  linesPricingMode: 'short_float',
  lineShortTenorYears: 0.25,
  depositLagMonths: 0,
  depositAnchorTenorYears: 0.5,
  depositRateFloor: null,
  depositRateFloorEnabled: false,
};

export const rmTypeDefaults = {
  //Commercial RM
  commercial_rm: {
    annualProduction: [
      { loans: 5000000, deposits: 1000000 },
      { loans: 7500000, deposits: 1500000 },
      { loans: 10000000, deposits: 2000000 },
      { loans: 12500000, deposits: 2500000 },
      { loans: 15000000, deposits: 3000000 }
    ],
    loanVsLinePercentage: 0.6,
    goingOnYields: [
      { loans: 0.0215, lines: 0.0215, deposits: 0.0300 },
      { loans: 0.0215, lines: 0.0215, deposits: 0.0325 },
      { loans: 0.0215, lines: 0.0215, deposits: 0.0350 },
      { loans: 0.0215, lines: 0.0215, deposits: 0.0375 },
      { loans: 0.0215, lines: 0.0215, deposits: 0.0400 }
    ],
    lineUtilizationPercentage: 0.55,
    originationFeePercentage: 0.0030,
    unusedCommitmentFeePercentage: 0.0030,
    salary: 125000,
    annualMeritIncrease: 0.035,
    incentiveCompensationPercentage: 0.20,
    discretionaryExpenses: 8000,
    deferredCostsPerLoan: 150,
    avgLoanExposureAtOrigination: 2000000,
    averageLifeLoans: 5.5,
    averageLifeLines: 3.5,
    prepayPercentageOfBalance: 0.12,
    averageLifeIncludesPrepay: false,
  },

  //Commercial RM Senior
  commercial_rm_senior: {
    annualProduction: [
      { loans: 7500000, deposits: 1500000 },
      { loans: 10000000, deposits: 2000000 },
      { loans: 12500000, deposits: 2500000 },
      { loans: 15000000, deposits: 3000000 },
      { loans: 17500000, deposits: 3500000 }
    ],
    loanVsLinePercentage: 0.6,
    goingOnYields: [
      { loans: 0.0215, lines: 0.0215, deposits: 0.0300 },
      { loans: 0.0215, lines: 0.0215, deposits: 0.0325 },
      { loans: 0.0215, lines: 0.0215, deposits: 0.0350 },
      { loans: 0.0215, lines: 0.0215, deposits: 0.0375 },
      { loans: 0.0215, lines: 0.0215, deposits: 0.0400 }
    ],
    lineUtilizationPercentage: 0.55,
    originationFeePercentage: 0.0030,
    unusedCommitmentFeePercentage: 0.0030,
    salary: 175000,
    annualMeritIncrease: 0.035,
    incentiveCompensationPercentage: 0.25,
    discretionaryExpenses: 3000,
    deferredCostsPerLoan: 150,
    avgLoanExposureAtOrigination: 2000000,
    averageLifeLoans: 5.5,
    averageLifeLines: 3.5,
    prepayPercentageOfBalance: 0.12,
    averageLifeIncludesPrepay: false,
  },

  //Private Banker
  private_banker: {
    annualProduction: [
      { loans: 6000000, deposits: 6000000 },
      { loans: 9000000, deposits: 9000000 },
      { loans: 12000000, deposits: 12000000 },
      { loans: 15000000, deposits: 15000000 },
      { loans: 18000000, deposits: 18000000 }
    ],
    loanVsLinePercentage: 0.6,
    goingOnYields: [
      { loans: 0.0175, lines: 0.0175, deposits: 0.0300 },
      { loans: 0.0175, lines: 0.0175, deposits: 0.0325 },
      { loans: 0.0175, lines: 0.0175, deposits: 0.0350 },
      { loans: 0.0175, lines: 0.0175, deposits: 0.0375 },
      { loans: 0.0175, lines: 0.0175, deposits: 0.0400 }
    ],
    lineUtilizationPercentage: 0.55,
    originationFeePercentage: 0.0020,
    unusedCommitmentFeePercentage: 0.0010,
    salary: 150000,
    annualMeritIncrease: 0.035,
    incentiveCompensationPercentage: 0.15,
    discretionaryExpenses: 1000,
    deferredCostsPerLoan: 150,
    avgLoanExposureAtOrigination: 750000,
    averageLifeLoans: 5.5,
    averageLifeLines: 3.5,
    prepayPercentageOfBalance: 0.12,
    averageLifeIncludesPrepay: false,
  },


  //Private Banker Senior
  private_banker_senior: {
    annualProduction: [
      { loans: 5000000, deposits: 1000000 },
      { loans: 7500000, deposits: 1500000 },
      { loans: 10000000, deposits: 2000000 },
      { loans: 12500000, deposits: 2500000 },
      { loans: 15000000, deposits: 3000000 }
    ],
    loanVsLinePercentage: 0.6,
    goingOnYields: [
      { loans: 0.0175, lines: 0.0175, deposits: 0.0300 },
      { loans: 0.0175, lines: 0.0175, deposits: 0.0325 },
      { loans: 0.0175, lines: 0.0175, deposits: 0.0350 },
      { loans: 0.0175, lines: 0.0175, deposits: 0.0375 },
      { loans: 0.0175, lines: 0.0175, deposits: 0.0400 }
    ],
    lineUtilizationPercentage: 0.55,
    originationFeePercentage: 0.0030,
    unusedCommitmentFeePercentage: 0.0030,
    salary: 100000,
    annualMeritIncrease: 0.035,
    incentiveCompensationPercentage: 0.25,
    discretionaryExpenses: 2000,
    deferredCostsPerLoan: 150,
    avgLoanExposureAtOrigination: 2000000,
    averageLifeLoans: 5.5,
    averageLifeLines: 3.5,
    prepayPercentageOfBalance: 0.12,
    averageLifeIncludesPrepay: false,
  },

  //Small Business Banker
  small_business_banker: {
    annualProduction: [
      { loans: 5000000, deposits: 1000000 },
      { loans: 7500000, deposits: 1500000 },
      { loans: 10000000, deposits: 2000000 },
      { loans: 12500000, deposits: 2500000 },
      { loans: 15000000, deposits: 3000000 }
    ],
    loanVsLinePercentage: 0.6,
    goingOnYields: [
      { loans: 0.0350, lines: 0.0350, deposits: 0.0300 },
      { loans: 0.0350, lines: 0.0350, deposits: 0.0325 },
      { loans: 0.0350, lines: 0.0350, deposits: 0.0350 },
      { loans: 0.0350, lines: 0.0350, deposits: 0.0375 },
      { loans: 0.0350, lines: 0.0350, deposits: 0.0400 }
    ],
    lineUtilizationPercentage: 0.55,
    originationFeePercentage: 0.0030,
    unusedCommitmentFeePercentage: 0.0030,
    salary: 100000,
    annualMeritIncrease: 0.035,
    incentiveCompensationPercentage: 0.25,
    discretionaryExpenses: 500,
    deferredCostsPerLoan: 150,
    avgLoanExposureAtOrigination: 2000000,
    averageLifeLoans: 5.5,
    averageLifeLines: 3.5,
    prepayPercentageOfBalance: 0.12,
    averageLifeIncludesPrepay: false,
  },

  //Small Business Banker Senior
  small_business_banker_senior: {
    annualProduction: [
      { loans: 5000000, deposits: 1000000 },
      { loans: 7500000, deposits: 1500000 },
      { loans: 10000000, deposits: 2000000 },
      { loans: 12500000, deposits: 2500000 },
      { loans: 15000000, deposits: 3000000 }
    ],
    loanVsLinePercentage: 0.6,
    goingOnYields: [
      { loans: 0.0350, lines: 0.0350, deposits: 0.0300 },
      { loans: 0.0350, lines: 0.0350, deposits: 0.0325 },
      { loans: 0.0350, lines: 0.0350, deposits: 0.0350 },
      { loans: 0.0350, lines: 0.0350, deposits: 0.0375 },
      { loans: 0.0350, lines: 0.0350, deposits: 0.0400 }
    ],
    lineUtilizationPercentage: 0.55,
    originationFeePercentage: 0.0030,
    unusedCommitmentFeePercentage: 0.0030,
    salary: 100000,
    annualMeritIncrease: 0.035,
    incentiveCompensationPercentage: 0.25,
    discretionaryExpenses: 1000,
    deferredCostsPerLoan: 150,
    avgLoanExposureAtOrigination: 2000000,
    averageLifeLoans: 5.5,
    averageLifeLines: 3.5,
    prepayPercentageOfBalance: 0.12,
    averageLifeIncludesPrepay: false,
  },

  //Mortgage Loan Officer
  mortgage_loan_officer: {
    annualProduction: [
      { loans: 5000000, deposits: 100000 },
      { loans: 7000000, deposits: 100000 },
      { loans: 9000000, deposits: 150000 },
      { loans: 11000000, deposits: 250000 },
      { loans: 13000000, deposits: 300000 }
    ],
    loanVsLinePercentage: 0.6,
    goingOnYields: [
      { loans: 0.0380, lines: 0.0380, deposits: 0.0300 },
      { loans: 0.0380, lines: 0.0380, deposits: 0.0325 },
      { loans: 0.0380, lines: 0.0380, deposits: 0.0350 },
      { loans: 0.0380, lines: 0.0380, deposits: 0.0375 },
      { loans: 0.0380, lines: 0.0380, deposits: 0.0400 }
    ],
    lineUtilizationPercentage: 0.55,
    originationFeePercentage: 0.0030,
    unusedCommitmentFeePercentage: 0.0030,
    salary: 85000,
    annualMeritIncrease: 0.02,
    incentiveCompensationPercentage: 0.25,
    discretionaryExpenses: 8000,
    deferredCostsPerLoan: 150,
    avgLoanExposureAtOrigination: 500000,
    averageLifeLoans: 0.3,
    averageLifeLines: 3.5,
    prepayPercentageOfBalance: 0.20,
    averageLifeIncludesPrepay: false,
  },

  //Mortgage Loan Officer Senior
  mortgage_loan_officer_senior: {
    annualProduction: [
      { loans: 6000000, deposits: 100000 },
      { loans: 8000000, deposits: 100000 },
      { loans: 10000000, deposits: 150000 },
      { loans: 12000000, deposits: 250000 },
      { loans: 14000000, deposits: 300000 }
    ],
    loanVsLinePercentage: 0.6,
    goingOnYields: [
      { loans: 0.0380, lines: 0.0380, deposits: 0.0300 },
      { loans: 0.0380, lines: 0.0380, deposits: 0.0325 },
      { loans: 0.0380, lines: 0.0380, deposits: 0.0350 },
      { loans: 0.0380, lines: 0.0380, deposits: 0.0375 },
      { loans: 0.0380, lines: 0.0380, deposits: 0.0400 }
    ],
    lineUtilizationPercentage: 0.3,
    originationFeePercentage: 0.020,
    unusedCommitmentFeePercentage: 0.0030,
    salary: 125000,
    annualMeritIncrease: 0.02,
    incentiveCompensationPercentage: 0.25,
    discretionaryExpenses: 2000,
    deferredCostsPerLoan: 450,
    avgLoanExposureAtOrigination: 600000,
    averageLifeLoans: 0.3,
    averageLifeLines: 3,
    prepayPercentageOfBalance: 0.20,
    averageLifeIncludesPrepay: false,
  },
  
  // Add more RM types with their specific default values
};

export const getDefaultsForRMType = (rmType) => {
  return {
    ...PRICING_DEFAULTS,
    ...(rmTypeDefaults[rmType] || {})
  };
};
